<section class="d-flex justify-content-between mt-2 w-100">
    <section class="btn-toolbar">
        <p class="ms-2">Periode: </p>
        <app-date-picker-dk
            class="ms-2"
            id="fra"
            #fraPicker="ngModel"
            name="fra"
            [maxDate]="tilPicker.value | ngbDateStruct"
            (ngModelChange)="onFraChange($event, fraPicker.valid)"
            [ngModel]="periode?.fra"></app-date-picker-dk>

        <app-date-picker-dk
            class="ms-2"
            id="til"
            #tilPicker="ngModel"
            name="til"
            [endOfDay]="true"
            [minDate]="fraPicker.value | ngbDateStruct"
            (ngModelChange)="onTilChange($event, tilPicker.valid)"
            [ngModel]="periode?.til"></app-date-picker-dk>

        <div class="ms-2">
            <p>LA: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="laselect" ngbDropdownToggle>{{ findLaName(laID) || 'Alle' }}</button>
            <div ngbDropdownMenu aria-labelledby="laselect">
                <button class="dropdown-item" (click)=onSelectLedelseAnsvarlig(null)>Alle</button>
                <button *ngFor="let medarbejder of laCards" class="dropdown-item" (click)="onSelectLedelseAnsvarlig(medarbejder.cardId)">{{medarbejder.fornavn}} {{medarbejder.efternavn}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>KA: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="kaselect" ngbDropdownToggle>{{ findKaName(kaID) || 'Alle' }}</button>
            <div ngbDropdownMenu aria-labelledby="kaselect">
                <button class="dropdown-item" (click)=onSelectKundeAnsvarlig(null)>Alle</button>
                <button *ngFor="let medarbejder of kaCards" class="dropdown-item" (click)="onSelectKundeAnsvarlig(medarbejder.cardId)">{{medarbejder.fornavn}} {{medarbejder.efternavn}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>SA: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="kaselect" ngbDropdownToggle>{{ findSaName(saID) || 'Alle' }}</button>
            <div ngbDropdownMenu aria-labelledby="kaselect">
                <button class="dropdown-item" (click)=onSelectSagsAnsvarlig(null)>Alle</button>
                <button *ngFor="let medarbejder of saCards" class="dropdown-item" (click)="onSelectSagsAnsvarlig(medarbejder.cardId)">{{medarbejder.fornavn}} {{medarbejder.efternavn}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>Koncern: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="koncernselect" ngbDropdownToggle>{{selectedKoncern || 'Alle'}}</button>
            <div ngbDropdownMenu aria-labelledby="koncernselect">
                <button (click)="onSelectKoncern(null)" class="dropdown-item">Alle</button>
                <button *ngFor="let koncern of koncerns" (click)="onSelectKoncern(koncern)" class="dropdown-item"> {{koncern}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>Vis alle: </p>
        </div>
        <div>
            <input class="ms-2" type="checkbox" [(ngModel)]="isChecked" (change)="onCheckboxChange()">
        </div>
    </section>
    <section class="btn-toolbar me-2">
        <div class="ms-2">
            <button (click)="onExportExcel()" class="btn btn--menu btn-primary btn-sm" type="submit">Eksport</button>
        </div>
    </section>
</section>
